/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_StartedInputs */

const en_status_started = /** @type {(inputs: Status_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started`)
};

const de_status_started = /** @type {(inputs: Status_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begonnen`)
};

/**
* | output |
* | --- |
* | "Started" |
*
* @param {Status_StartedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_started = /** @type {((inputs?: Status_StartedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_StartedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_status_started(inputs)
	return en_status_started(inputs)
});